import type { ButtonHTMLAttributes, ReactNode } from 'react'

type ButtonVariant = 'primary' | 'outline' | 'ghost' | 'cyan'
type ButtonSize = 'sm' | 'md'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  variant?: ButtonVariant
  size?: ButtonSize
}

const variantClasses: Record<ButtonVariant, string> = {
  outline:
    'bg-surface-card dark:bg-dark-card text-ink dark:text-dark-ink border-2 border-ink dark:border-dark-border shadow-[2px_2px_0_#111111] dark:shadow-[2px_2px_0_#000000] hover:-translate-x-px hover:-translate-y-px hover:shadow-[3px_3px_0_#111111] dark:hover:shadow-[3px_3px_0_#000000] active:translate-x-px active:translate-y-px active:shadow-none',
  primary:
    'bg-ink text-surface dark:bg-dark-card dark:text-dark-ink border-2 border-ink dark:border-dark-border shadow-[2px_2px_0_#111111] dark:shadow-[2px_2px_0_#000000] hover:opacity-80',
  cyan: 'bg-cyan text-ink border-2 border-ink dark:border-ink shadow-[2px_2px_0_#111111] dark:shadow-[2px_2px_0_#000000] hover:-translate-x-px hover:-translate-y-px hover:shadow-[3px_3px_0_#111111] active:translate-x-px active:translate-y-px active:shadow-none',
  ghost:
    'bg-transparent text-ink dark:text-dark-ink hover:bg-surface-muted dark:hover:bg-dark-bg2',
}

const sizeClasses: Record<ButtonSize, string> = {
  sm: 'py-[7px] px-[13px] text-[11px]',
  md: 'py-3.5 px-4 text-xs',
}

export function Button({
  children,
  variant = 'outline',
  size = 'sm',
  className = '',
  ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      className={`inline-flex items-center gap-1.5 font-extrabold tracking-widest uppercase rounded-lg transition-[transform,box-shadow] cursor-pointer focus:outline-none focus:ring-2 disabled:cursor-not-allowed ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
